export const endpoints = {
  session: '/session',
  sessionLocation: '/session/location',
  invitations: {
    create: '/invitations',
    list: '/invitations',
    roles: '/invitations/roles',
    revoke: (invitationId: string) => `/invitations/${encodeURIComponent(invitationId)}`,
    preview: (token: string) => `/invitations/${encodeURIComponent(token)}`,
    accept: (token: string) => `/invitations/${encodeURIComponent(token)}/accept`,
  },
  /** Recorded against whichever subject raised them, so they belong to no single area. */
  activities: '/activities',
  appointments: '/appointments',
  sales: '/sales',
  customers: {
    list: '/customers',
    detail: (customerId: string) => `/customers/${customerId}`,
    creditGrants: (customerId: string) => `/customers/${customerId}/credit-grants`,
  },
  scheduler: {
    calendar: '/calendar',
    appointments: '/appointments',
    appointmentCheckIn: (appointmentId: string) => `/appointments/${appointmentId}/check-in`,
  },
  billing: {
    packages: '/packages',
    checkoutIntents: '/checkout-intents',
    purchases: (customerId: string) => `/customers/${customerId}/purchases`,
    refunds: (purchaseId: string) => `/purchases/${purchaseId}/refunds`,
    endPlan: (purchaseId: string) => `/purchases/${purchaseId}/end-plan`,
    cashSales: '/cash-sales',
  },
  platform: {
    ablefyProducts: '/platform/ablefy-products',
    ablefyProduct: (productId: string) => `/platform/ablefy-products/${productId}`,
    readyForSale: '/platform/ablefy-products/ready-for-sale',
  },
  catalogue: {
    ablefyProducts: '/ablefy-products',
    ablefyProduct: (productId: string) => `/ablefy-products/${productId}`,
    readyForSale: '/ablefy-products/ready-for-sale',
  },
  notifications: {
    list: '/notifications',
  },
  settings: {
    workspace: '/settings/workspace',
  },
  workspace: {
    settings: '/workspace/settings',
    logo: '/workspace/settings/logo',
    stageLabels: '/workspace/stage-labels',
  },
  pipeline: {
    board: '/pipeline',
    leads: '/leads',
    activities: '/activities',
    appointments: '/appointments',
    sales: '/sales',
    leadStage: (leadId: string) => `/leads/${leadId}/stage`,
  },
  calls: {
    list: '/call-list',
    outcomes: '/call-outcomes',
    activities: '/activities',
    appointments: '/appointments',
  },
  /** Website-Formular — the active Standort's key for its website's lead form. */
  websiteIntake: '/website-intake',
  /** Analysen — `docs/frontend-handoff-2026-10-30-analytics.md` §4. */
  analytics: {
    summary: '/analytics/summary',
    breakdown: '/analytics/breakdown',
  },
  /** Company and franchise admin panels — spec `2026-10-27-company-and-franchise-admin-design`. */
  organization: '/organization',
  switches: '/switches',
  staff: {
    list: '/staff',
    block: (staffId: string) => `/staff/${encodeURIComponent(staffId)}/block`,
    unblock: (staffId: string) => `/staff/${encodeURIComponent(staffId)}/unblock`,
  },
  priceRequests: {
    list: '/price-requests',
    approve: (requestId: string) => `/price-requests/${encodeURIComponent(requestId)}/approve`,
    reject: (requestId: string) => `/price-requests/${encodeURIComponent(requestId)}/reject`,
    withdraw: (requestId: string) => `/price-requests/${encodeURIComponent(requestId)}/withdraw`,
  },
} as const

/** STOMP destinations. `/user/**` maps to Spring's per-session user destinations. */
export const topics = {
  notifications: '/user/queue/notifications',
} as const
